<template>
  <div id="widget">
    <div id="other-widget" class="explore_entity_inside pragya_web_widget apply-font">

      <div class="d-none" v-if="institutionMeta.fontFamily">
        <font-picker :api-key="apiKey" :active-font="institutionMeta.fontFamily" :options="{name: 'srf'}"></font-picker>
      </div>

      <div class="pg_content">
        <p v-if="!isDataLoaded" class="text-center">Loading Career Outlook Information…</p>
        <div class="filter-row program-guide-section" v-if="isDataLoaded">
          <template v-if="isAuthenticated">
            <div class="mid-panel filter-panel">
              <template v-if="isShowDUWidget || isEMSIFeatureEnabled">
                <div class="pg_sec">
                  <div class="row widget_dropdown_section" v-if="showMajorDropDown">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 filter_select_section">
                      <b-input-group class="row frm_sec">
                        <div class="col-11 frm_fld_col">
                          <div class="row">
                            <template v-if="isShowCategoryAsSeparateDropdownEnabled">
                              <template v-if="categories">
                                <div class="frm_fld category">
                                  <label for="state">Select {{categoryLabel}}</label>
                                  <v-select class="select-field" v-model="selectedCategory"
                                    :options="categories" label="name" :placeholder="'Select Any ' + categoryLabel" :clearable="false"></v-select>
                                  <span class="fld_info"></span>
                                </div>
                                <div class="frm_label"></div>
                              </template>
                            </template>
                            <template v-if="majors">
                              <div class="frm_fld program">
                                <label for="state">Select {{programLabel}}</label>
                                <v-select class="select-field" v-model="selectedMajor"
                                  :options="majorsToShow" label="name" :placeholder="'Select Any ' + programLabel" :clearable="false"></v-select>
                                <span class="fld_info"></span>
                              </div>
                            </template>
                          </div>
                        </div>
                      </b-input-group>
                    </div>
                  </div>
                </div>
                <template v-if="cipCode && cipCode !== 'null' && cipCode !== null">
                  <du-program-guide-career-prospects-detail :cipCode="cipCode" :programGuideCode="programGuideCode" :isShowLess="isShowLess" :key="programGuideKey" :isWidget="'true'" :institutionId="institutionId" :majorTitle="selectedMajorTitle"></du-program-guide-career-prospects-detail>
                </template>
                <template v-if="!cipCode || cipCode === 'null' || cipCode === null">
                  <div class="widget_screen_container">
                    <div class="widget_screen_layer">
                      <div class="msg">{{selectProgramLabel}}</div>
                    </div>
                  </div>
                </template>
              </template>
              <template v-else>
                <widget-program-guide-career-prospects-detail :cipCode="cipCode" :programGuideCode="programGuideCode" :key="programGuideKey" :institutionId="institutionId" :majorTitle="selectedMajorTitle" :introductionMessage="introductionMessage" :demoWidget="demoWidget" :state="state" :msa="msa" :privacyPolicyLink="institutionMeta.privacyPolicyLink">
                </widget-program-guide-career-prospects-detail>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="text-center" style="margin-top: 40px;">
              <h3>You are not authorized. Please contact your administrator.</h3>
            </div>
          </template>
        </div>
        <div class="data_source_info" v-if="isDataLoaded && isBGTFeatureEnabled">
          Source: Most recent Burning Glass Technologies data available. Powered by <a href="https://site.pragyasystems.com/enrollment" target="_blank"> Pragya Systems</a>
        </div>
        <div class="data_source_info" v-if="isDataLoaded && !isBGTFeatureEnabled && isLightcastEnabled">
          Source: Most recent Lightcast data available. Powered by <a href="https://site.pragyasystems.com/enrollment" target="_blank"> Pragya Systems</a>
        </div>
        <div class="data_source_info" v-if="isDataLoaded && !isBGTFeatureEnabled && !isLightcastEnabled">
          Source: Most recent Career One Stop and BLS data available. Powered by <a href="https://site.pragyasystems.com/enrollment" target="_blank"> Pragya Systems</a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapState, mapActions } from 'vuex'
  import ProgramGuideCareerProspectsDetail from './programguide/components/ProgramGuideCareerProspectsDetail'
  import WidgetProgramGuideCareerProspectsDetail from './programguide/components/WidgetProgramGuideCareerProspectsDetail'
  import DuProgramGuideCareerProspectsDetail from './programguide/components/DuProgramGuideCareerProspectsDetail'
  // import '../assets/theme/default/css/defaultTheme.min.css'
  import '../assets/theme/default/sass/global.scss'
  import '../assets/module/sass/explore/explore.scss'
  import FontPicker from 'font-picker-vue'
  import { PACKAGE } from '../package_constants'
  import { StorageFactory } from '../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'pragya-widget',
    props: ['prop1', 'prop2', 'prop3', 'prop4', 'prop5', 'prop6', 'prop7'],
    components: {
      ProgramGuideCareerProspectsDetail,
      'font-picker': FontPicker,
      WidgetProgramGuideCareerProspectsDetail,
      DuProgramGuideCareerProspectsDetail
    },
    data: () => {
      return {
        key: '',
        secret: '',
        cipCode: '',
        programGuideCode: '',
        state: '',
        msa: '',
        isShowLess: false,
        isDataLoaded: false,
        isAuthenticated: false,
        selectedState: null,
        selectedMetroArea: null,
        selectedCounty: null,
        disableSelectState: false,
        disableSelectMetroArea: false,
        disableSelectCounty: false,
        topSkillsItems: [],
        topCompaniesItems: [],
        targetOccupationItems: [],
        topSkillsFields: ['Skill', 'Postings with Skill'],
        institutionId: '',
        showMajorDropDown: false,
        majors: [],
        majorsToShow: [],
        selectedMajor: {},
        selectedMajorTitle: '',
        selectedCategory: '',
        programGuideKey: 0,
        isShowDUWidget: false,
        introductionMessage: '',
        apiKey: 'AIzaSyAa3D-xZhJGxFRI2cxDX6iInTwA4hKy3pc',
        demoWidget: false,
        institutionMeta: {}
      }
    },

    beforeMount () {
      this.$nextTick(() => {
        window.addEventListener('message', (event) => {
          this.isShowDUWidget = (event.data.name === 'LOAD_OLD_WIDGET')
        })
      })
    },

    mounted () {
      if (this.prop1 && this.prop1.length > 0 && this.prop2 && this.prop2.length > 0) {
        this.key = this.prop1
        this.secret = this.prop2
        this.cipCode = this.prop3
        this.programGuideCode = this.prop4
        this.state = this.prop5
        this.msa = this.prop6
        if (this.prop7) {
          localStore.setItem('pragya_environment', this.prop7)
        }
        this.authenticateWidget()
      } else if (this.$route.query) {
        this.key = this.$route.query.key
        this.secret = this.$route.query.secret
        this.cipCode = this.$route.query.cipCode
        this.programGuideCode = this.$route.query.programGuideCode
        this.state = this.$route.query.state
        this.msa = this.$route.query.msa
        this.authenticateWidget()
      } else {
        this.isDataLoaded = true
      }
    },

    methods: {
      ...mapActions([
        'loadAuthenticateWidget',
        'loadWidgetIntroductionMessage',
        'loadWidgetDemoWidget',
        'loadLoginGuestUser',
        'loadProgramCareerResult',
        'resetProgramCareerResult',
        'loadGeoIds',
        'loadInstitutionPackage',
        'loadMajorMinors',
        'loadPragyaMajorMinors',
        'loadLogDashboardActivity',
        'loadInstitutionTermMap',
        'loadInstitutionMetaInfoForSelfRegistration'
      ]),

      async authenticateWidget () {
        this.introductionMessage = await this.loadWidgetIntroductionMessage({key: this.key, secret: this.secret})
        this.demoWidget = await this.loadWidgetDemoWidget({key: this.key, secret: this.secret})
        this.loadAuthenticateWidget({key: this.key, secret: this.secret}).then(institutionId => {
          console.log('Institution Id: ', institutionId)
          if (institutionId) {
            this.institutionId = institutionId

            // Set Theme
            this.loadInstitutionMetaInfoForSelfRegistration(institutionId).then(institutionMeta => {
              let root = document.documentElement
              this.institutionMeta = institutionMeta
              root.style.setProperty('--InstFontFamily', institutionMeta.fontFamily) // Font Family
              root.style.setProperty('--TU__BaseTxtClr', institutionMeta.backgroundColor) // Other Text Color
              root.style.setProperty('--TU__BtnClrPri', institutionMeta.primaryColor) // Button Color
              root.style.setProperty('--TU__BtnTxtClrPri', institutionMeta.secondaryColor) // Button Text Color
              root.style.setProperty('--TU__BtnHoverClrPri', institutionMeta.buttonHoverColor) // Button Hover Color
              root.style.setProperty('--TU__BtnTxtHoverClrPri', institutionMeta.secondaryColor) // Button Text Color
              root.style.setProperty('--TU__BtnClrSec', institutionMeta.primaryColor) // Button Color
              root.style.setProperty('--TU__BtnHoverClrSec', institutionMeta.buttonHoverColor)  // Button Hover Color
              root.style.setProperty('--TU__LnkClrPri', institutionMeta.linkColor) // Link Color
              root.style.setProperty('--TU__LnkHoverClrPri', institutionMeta.linkHoverColor) // Link Hover Color
              root.style.setProperty('--TU__LnkClrSec', institutionMeta.backgroundColor) // Other Text Color
              root.style.setProperty('--TU__LnkHoverClrSec', institutionMeta.backgroundColor) // Other Text Color
            })

            this.loadLoginGuestUser({institutionId: institutionId, isWidgetAdminDash: false}).then(token => {
              if (token) {
                this.loadInstitutionPackage({uuid: institutionId, isAggregated: false}).then(res => {
                  this.isAuthenticated = true
                  let customCSSFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CUSTOM_CSS_ON_WIDGET]
                  if (customCSSFeature && customCSSFeature.enabled) {
                    $('#widget').find('#other-widget').addClass(customCSSFeature.label)
                  }
                  this.loadGeoIds()
                  if ((!this.cipCode || (this.cipCode === 'null')) && (!this.programGuideCode || (this.programGuideCode === 'null'))) {
                    this.loadLogDashboardActivity({action: 'widgetRenderedWithProgramList', page: 'programCareerProspectsWidget', link: '', programCipCode: ''})
                    this.loadMajorMinors({page: 0, count: 5000, name: '', skipMinor: true}).then(result => {
                      this.majors = result.content
                      if (!this.isShowCategoryAsSeparateDropdownEnabled) {
                        this.majorsToShow = result.content
                        this.majorsToShow.sort((a, b) => (a.name >= b.name) ? 1 : -1)
                      }
                      if (this.majors.length > 0) {
                        if (!this.isShowSelectProgramMessageEnabled) {
                          this.selectedMajor = this.majors[0]
                          this.cipCode = this.selectedMajor.cipCode
                          this.programGuideCode = this.selectedMajor.code
                          this.selectedMajorTitle = this.selectedMajor.name
                        }
                      } else {
                        this.loadPragyaMajorMinors().then(res => {
                          this.majors = res
                          this.majorsToShow = res
                          this.majorsToShow.sort((a, b) => (a.name >= b.name) ? 1 : -1)
                          if (this.majors.length > 0) {
                            if (!this.isShowSelectProgramMessageEnabled) {
                              this.selectedMajor = this.majors[0]
                              this.cipCode = this.selectedMajor.cipCode
                              this.selectedMajorTitle = this.selectedMajor.name
                            }
                          }
                        })
                      }
                      this.showMajorDropDown = true
                      this.isDataLoaded = true
                    })
                  } else {
                    this.loadLogDashboardActivity({action: 'widgetRenderedFromProgramPage', page: 'programCareerProspectsWidget', link: '', programCipCode: this.cipCode, programCode: this.programGuideCode})
                    this.isDataLoaded = true
                  }
                  this.loadInstitutionTermMap({uuid: institutionId, excludePastCutOff: true})
                })
              }
            })
          } else {
            this.isAuthenticated = false
          }
        })
      },

      getLocationParamForCareerSearch () {
        let locationParam = null
        let selectedState = (this.selectedState && this.selectedState.label) ? this.selectedState.label : null
        let selectedMetroArea = (this.selectedMetroArea && this.selectedMetroArea.label) ? this.selectedMetroArea.label : null
        let selectedCounty = (this.selectedCounty && this.selectedCounty.label) ? this.selectedCounty.label : null

        if (selectedState) {
          locationParam = 'state:' + this.labelsToCodesMap.stateGeoIds[selectedState]
        } else if (selectedMetroArea) {
          locationParam = 'msa:' + this.labelsToCodesMap.msaGeoIds[selectedMetroArea]
        } else if (selectedCounty) {
          locationParam = 'county:' + this.labelsToCodesMap.countyGeoIds[selectedCounty]
        }
        return locationParam
      },

      careerSearchClicked () {
        let careerCode = this.formattedCareer.code
        if (!careerCode) {
          return
        }
        this.$refs.loadingModal.show()
        let locationParam = this.getLocationParamForCareerSearch()
        if (locationParam) {
          this.loadProgramCareerResult({careerCode: careerCode, locationParam: locationParam}).then(response => {
            this.$refs.loadingModal.hide()
            if (!response) {
              this.$notify({
                group: 'notify',
                type: 'warning',
                title: '',
                text: 'Career search returned zero results.'
              })
            }
            this.$forceUpdate()
          })
        } else {
          setTimeout(() => {
            this.$store.commit('LOAD_PROGRAM_CAREER_RESULT', {})
            this.$refs.loadingModal.hide()
            this.$forceUpdate()
          }, 1000)
        }
      },

      formatOptionsForVSelect (map) {
        let formatted = []
        Object.keys(map).sort().forEach((key, i) => {
          formatted.push({id: key, label: map[key]})
        })
        return formatted
      },

      resetData () {
        this.topSkillsItems = []
        this.topCompaniesItems = []
        this.targetOccupationItems = []
        this.resetProgramCareerResult()
      },

      updateMajorsToShow () {
        this.majorsToShow = []
        if (this.majors.length > 0) {
          this.majors.forEach((item, i) => {
            item.category.forEach((cat, j) => {
              if (cat === this.selectedCategory) {
                this.majorsToShow.push(item)
              }
            })
          })
          this.majorsToShow.sort((a, b) => (a.name >= b.name) ? 1 : -1)
          if(this.majorsToShow && this.majorsToShow.length>0){
              this.selectedMajor = this.majorsToShow[0]
          }
        }
      }
    },

    computed: {
      ...mapState({
        'careersObject': state => state.programguide.careers,
        'careerResult': state => state.programguide.careerResult,
        'geoIdMap': state => state.career.geoIdMap,
        'enabledFeatures': state => state.institution.enabledFeatures
      }),
      isShowCategoryAsSeparateDropdownEnabled () {
        let separteDropdown = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_CATEGORY_AS_SEPARATE_DROPDOWN]
        return separteDropdown && separteDropdown.enabled
      },
      selectDefaultCatagory () {
         this.selectedMajor = {}
         this.selectedCategory = this.categories[0]
//         this.updateMajorsToShow()
         return true
      },
      isBGTFeatureEnabled () {
        let bgtFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_BGT_SOURCE]
        return bgtFeature && bgtFeature.enabled
      },
      isLightcastEnabled () {
        let lightcastFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_LIGHTCAST_SOURCE]
        return lightcastFeature && lightcastFeature.enabled
      },
      isEMSIFeatureEnabled () {
        let emsiFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_EMSI_SOURCE]
        return emsiFeature && emsiFeature.enabled
      },
      categoryLabel () {
        let label = 'Category'
        let separteDropdown = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_CATEGORY_AS_SEPARATE_DROPDOWN]
        if (separteDropdown && separteDropdown.enabled) {
          label = separteDropdown.label
        }
        return label
      },
      programLabel () {
        let label = 'Program'
        let programFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
        if (programFeature && programFeature.enabled && programFeature.label) {
          label = programFeature.label
        }
        return label
      },
      isShowSelectProgramMessageEnabled () {
        let showMessage = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_SELECT_PROGRAM_MESSAGE]
        return showMessage && showMessage.enabled
      },
      selectProgramLabel () {
        let label = 'Start exploring careers by selecting a program and/or concentration/major above.'
        let showMessage = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_SELECT_PROGRAM_MESSAGE]
        if (showMessage && showMessage.enabled) {
          label = showMessage.label
        }
        return label
      },
      categories () {
        if (this.majors.length > 0) {
          let categories = []
          this.majors.forEach((item, i) => {
            item.category.forEach((cat, j) => {
              if (categories.indexOf(cat) === -1) {
                categories.push(cat)
              }
            })
          })
          return categories.sort()
        }
        return []
      },
      formattedCareer () {
        let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
        if (!formattedCareer || !formattedCareer.uuid) {
          return {}
        }
        this.resetData()
        formattedCareer.targetOccupations.forEach((career, i) => {
          let curr = JSON.parse(career)
          if (i === 0) {
            formattedCareer.timeframe = curr.timeframe
            formattedCareer.endYear = curr.year
            formattedCareer.startYear = formattedCareer.endYear - 10
            formattedCareer.tenYearOldJobTitle = curr.tenYearOldJobTitle
          }
          let tenYearOldJobTitle = formattedCareer.tenYearOldJobTitle
          let growthTitle = 'Growth (' + formattedCareer.timeframe + ')'
          let currItem = {
            'Occupation': curr.name,
            'Annual Openings': curr.annualOpening,
            'Median Hourly Earnings': curr.medianHourlyEarning
          }
          currItem[tenYearOldJobTitle] = curr.tenYearOldJob
          currItem[growthTitle] = curr.growth
          this.targetOccupationItems.push(currItem)
        })

        formattedCareer.topPostingCompanies.forEach((company, i) => {
          let curr = JSON.parse(company)
          let tenYearPostingTitle = 'Total/Unique (' + formattedCareer.timeframe + ')'
          let currItem = {'Company': curr.name}
          currItem[tenYearPostingTitle] = curr.total_postings + ' / ' + curr.unique_postings
          currItem['Posting Intensity'] = (Math.round(curr.posting_intensity)) + ':1'
          this.topCompaniesItems.push(currItem)
        })

        formattedCareer.topSkills.forEach((skill, i) => {
          let curr = JSON.parse(skill)
          let currItem = {'Skill': curr.name, 'Postings with Skill': curr.unique_postings}
          this.topSkillsItems.push(currItem)
        })
        return formattedCareer
      },
      labelsToCodesMap () {
        let map = this.geoIdMap
        let formattedMap = {}
        if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
          formattedMap.stateGeoIds = _.invert(map.stateGeoIds)
          formattedMap.msaGeoIds = _.invert(map.msaGeoIds)
          formattedMap.countyGeoIds = _.invert(map.countyGeoIds)
        }
        return formattedMap
      },
      formattedGeoIdMap () {
        let formattedMap = {}
        let map = this.geoIdMap

        if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
          formattedMap.stateGeoIds = this.formatOptionsForVSelect(map.stateGeoIds)
          formattedMap.msaGeoIds = this.formatOptionsForVSelect(map.msaGeoIds)
          formattedMap.countyGeoIds = this.formatOptionsForVSelect(map.countyGeoIds)
        }
        return formattedMap
      },
      targetOccupationFields () {
        let fields = ['Occupation']
        if (this.formattedCareer.targetOccupations && this.formattedCareer.targetOccupations.length > 0) {
          let curr = JSON.parse(this.formattedCareer.targetOccupations[0])
          fields.push((curr.tenYearOldJobTitle))
          fields.push('Annual Openings')
          fields.push('Median Hourly Earnings')
          fields.push('Growth (' + curr.timeframe + ')')
          return fields
        } else {
          return []
        }
      },
      topCompaniesFields () {
        let fields = ['Company']
        if (this.formattedCareer.targetOccupations && this.formattedCareer.targetOccupations.length > 0) {
          let curr = JSON.parse(this.formattedCareer.targetOccupations[0])
          fields.push('Total/Unique (' + curr.timeframe + ')')
          fields.push('Posting Intensity')
          return fields
        } else {
          return []
        }
      }
    },

    watch: {
      selectedCategory (newCategory) {
        if (this.isShowSelectProgramMessageEnabled) {
          this.selectedMajor = {}
          this.cipCode = ''
          this.programGuideCode = ''
          this.programGuideKey = this.programGuideKey + 1
        }
        this.updateMajorsToShow()
      },
      selectedMajor (newSelectedMajor) {
        this.cipCode = this.selectedMajor.cipCode
        this.programGuideCode = this.selectedMajor.code
        this.programGuideKey = this.programGuideKey + 1
      },
      selectedState (newState) {
        if (!newState) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
          this.disableSelectCounty = false
        } else {
          this.disableSelectState = false
          this.disableSelectMetroArea = true
          this.disableSelectCounty = true
        }
      },
      selectedMetroArea (newMSA) {
        if (!newMSA) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
          this.disableSelectCounty = false
        } else {
          this.disableSelectState = true
          this.disableSelectMetroArea = false
          this.disableSelectCounty = true
        }
      },
      selectedCounty (newCounty) {
        if (!newCounty) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
          this.disableSelectCounty = false
        } else {
          this.disableSelectState = true
          this.disableSelectMetroArea = true
          this.disableSelectCounty = false
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// widgetSrc/app/WebWidgetApp.vue